import { render } from "./permanent-documents-uploader.vue?vue&type=template&id=0f41656c"
import script from "./permanent-documents-uploader.vue?vue&type=script&lang=js"
export * from "./permanent-documents-uploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__